import { Component } from '@angular/core';

@Component({
  selector: 't-home-icon',
  standalone: true,
  imports: [],
  templateUrl: './home-icon.component.html',
  styleUrl: './home-icon.component.css',
})
export class HomeIconComponent {}
